import { render } from "./Form1.vue?vue&type=template&id=b77765e6&scoped=true"
import script from "./Form1.vue?vue&type=script&lang=js"
export * from "./Form1.vue?vue&type=script&lang=js"

import "./Form1.vue?vue&type=style&index=0&id=b77765e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77765e6"]])

export default __exports__